module.exports = __webpack_public_path__ + "img/question-gem.6baf6d78.svg";